import(/* webpackMode: "eager" */ "/app/apps/ashtrom-concessions/app/[locale]/not-found.tsx");
